import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { NODE_HEIGHT, NODE_WIDTH } from "../constants";
function EmptyStepPlaceholderNode({ data }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Handle, {
                type: "target",
                position: Position.Left,
                isConnectable: false,
                style: {
                    opacity: 0
                }
            }),
            /*#__PURE__*/ _jsxs("button", {
                type: "button",
                className: "nodrag nopan flex items-center justify-center gap-1 rounded-md border-2 border-dashed border-muted-foreground/40 bg-background text-xs text-muted-foreground hover:border-primary hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                style: {
                    width: NODE_WIDTH,
                    height: NODE_HEIGHT
                },
                onClick: (event)=>{
                    // Keeps the click off the canvas selection handlers.
                    event.stopPropagation();
                    void data.onActivate();
                },
                onContextMenu: (event)=>{
                    // Radix skips opening its menu for a default-prevented event.
                    event.preventDefault();
                    event.stopPropagation();
                },
                children: [
                    /*#__PURE__*/ _jsx(Plus, {
                        className: "size-4"
                    }),
                    t("processDraft.addStep")
                ]
            })
        ]
    });
}
export default /*#__PURE__*/ memo(EmptyStepPlaceholderNode);

//# sourceMappingURL=EmptyStepPlaceholderNode.js.map